import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import toast from 'react-hot-toast';
import GridProviderFajlovi from './components/GridProviderFajlovi';
import MuiDialog from '../../../../UI/MuiDialog/MuiDialog';
import NoviFajl from './components/NoviFajl';
import Spinner from '../../../../UI/Modal/Spinner';
import styles from './Files.module.css';
import PregledSlikaPopupUniverzalno from '../../../../UI/PregledSlika/PregledSlikaPopupUniverzalno';
import useHttp from '../../../../../hooks/use-http';
import { handleErrorMessage } from '../../../../../../shared/api/handleErrorMessage';
import { urls } from '../../api/urls';

const Dokumentacija = ({
  idMasine,
  metadataFaze,
  aktiviranProjekat,
  onDokumentiChanged,
}) => {
  const { t } = useTranslation();
  const {
    sendRequest: getGridData,
    data: gridData,
    isLoading: isLoadingGrid,
  } = useHttp('');
  const initialDokumenti = {
    id: 0,
    idVrsteDokOpste: 0,
    nazivVrsteDokOpste: '',
    opis: '',
  };
  const [selectedImg, setSelectedImg] = useState('');
  const { getData: insertFajlovaNas, isLoading: loadingFajloviNas } =
    useHttp('');
  const { getData: deleteDokument, isLoading: loadingDelete } = useHttp('');
  const [openDocument, setOpenDocument] = useState(false);
  const [openNewDocument, setOpenNewDocument] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [documentId, setDocumentId] = useState(0);
  const [file, setFile] = useState([]);
  const [openPath, setOpenPath] = useState(null);
  const [formData, setFormData] = useState(initialDokumenti);

  const canManage = localStorage.idFirme === '1';

  const vratiGrid = () => {
    if (!idMasine) return;

    const config = {
      method: 'POST',
      url: urls.GET_DOKUMENTI,
      data: {
        idMasine: idMasine,
        metadata: metadataFaze,
      },
    };
    getGridData(config);
  };
  useEffect(() => {
    vratiGrid();
  }, []);
  const handleOpenFile = (item) => {
    if (item.type && item.type.startsWith('image')) {
      setSelectedImg(item.path);
    } else {
      setOpenPath(item.path);
      setOpenDocument(true);
    }
  };
  const handleOpenNewDocument = () => {
    setOpenNewDocument(true);
  };
  const handleNovi = () => {
    setFile([]);
    setFormData(initialDokumenti);
  };

  const handleSaveDokument = async () => {
    if (formData.idVrsteDokOpste === null || formData.idVrsteDokOpste === 0) {
      toast.error(t('projectProgress.documentTypeRequiredToast'));
      return;
    }
    if (file.length === 0) {
      toast.error(t('projectProgress.fileRequiredToast'));
      return;
    }
    if (!idMasine) {
      toast.error(t('projectProgress.errorUpdatingData'));
      return;
    }

    const fdNas = new FormData();
    fdNas.append('idMasine', idMasine);
    if (metadataFaze) fdNas.append('metadataFaze', metadataFaze);
    fdNas.append('idVrsteDokumenta', formData.idVrsteDokOpste);
    fdNas.append('opis', formData.opis ?? '');
    fdNas.append('idKorProm', +localStorage.idKorisnika);
    for (let i = 0; i < file.length; i += 1) {
      fdNas.append('dokumenti', file[i], file[i].path || file[i].name);
    }

    const resultNas = await insertFajlovaNas({
      method: 'POST',
      url: urls.INSERT_DOKUMENT,
      data: fdNas,
    });

    if (resultNas?.isAxiosError) {
      toast.error(handleErrorMessage(resultNas));
      return;
    }

    const rezultat = Number(resultNas?.rezultat ?? resultNas?.Rezultat ?? 0);
    if (rezultat <= 0) {
      toast.error(
        resultNas?.opis ||
          resultNas?.Opis ||
          t('projectProgress.errorUpdatingData'),
      );
      return;
    }

    toast.success(t('projectProgress.successfulEntry'));
    setFile([]);
    handleNovi();
    setOpenNewDocument(false);
    vratiGrid();
    if (onDokumentiChanged) {
      await onDokumentiChanged();
    }
  };
  const handleOpenDeleteDialog = (id) => {
    setOpenDeleteDialog(true);
    setDocumentId(id);
  };
  const handleDelete = async () => {
    const result = await deleteDokument({
      method: 'POST',
      url: urls.DELETE_DOKUMENT,
      data: {
        id: documentId,
        idKorProm: +localStorage.idKorisnika,
      },
    });

    if (result?.isAxiosError) {
      toast.error(handleErrorMessage(result));
      return;
    }

    if (result) {
      const rezultat = Number(result?.rezultat ?? result?.Rezultat ?? 1);
      if (rezultat <= 0) {
        toast.error(
          result?.opis ||
            result?.Opis ||
            t('projectProgress.errorUpdatingData'),
        );
        return;
      }

      setDocumentId(0);
      setOpenDeleteDialog(false);
      vratiGrid();
      if (onDokumentiChanged) {
        await onDokumentiChanged();
      }
      return;
    }

    toast.error(handleErrorMessage(result));
  };
  // const downloadFile = (item) => {
  //   const downloadLink = document.createElement('a');
  //   downloadLink.href = item.path;
  //   downloadLink.download = item.name;
  //   downloadLink.target = '_blank';
  //   downloadLink.click();
  // };

  const downloadFile = async (fileUrl, fileName) => {
    const config = {
      method: 'POST',
      url: 'Dokumenta/konvertovanje_base64',
      data: { vrednost: fileUrl },
    };

    const response = await deleteDokument(config);

    const base64Data = response; // Pretpostavljam da response.data sadrži base64 string.

    // Konvertovanje base64 stringa u Blob objekt
    const byteCharacters = atob(base64Data);
    const byteNumbers = Array.from(byteCharacters, (char) =>
      char.charCodeAt(0),
    );
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    // Kreiranje URL-a za Blob objekt
    const blobUrl = URL.createObjectURL(blob);

    // Kreiranje i klikanje na link element za preuzimanje datoteke
    const link = document.createElement('a');
    link.href = blobUrl;
    link.setAttribute('download', fileName); // Postavite naziv datoteke
    document.body.appendChild(link);
    link.click();

    // Čišćenje URL-a i uklanjanje linka
    URL.revokeObjectURL(blobUrl);
    document.body.removeChild(link);
  };
  return (
    <div>
      {(loadingFajloviNas || loadingDelete) && <Spinner />}{' '}
      {canManage && (
        <div
          style={{ cursor: 'pointer', width: 'fit-content' }}
          onClick={handleOpenNewDocument}
        >
          <i className="fas fa-plus-circle" /> {t('projectProgress.new')}
        </div>
      )}
      <GridProviderFajlovi
        data={gridData}
        loading={isLoadingGrid}
        handleOpenFile={handleOpenFile}
        handleOpenDeleteDialog={handleOpenDeleteDialog}
        downloadFile={downloadFile}
        aktiviranProjekat={aktiviranProjekat}
        canManage={canManage}
      />{' '}
      {selectedImg && (
        <PregledSlikaPopupUniverzalno
          selectedImg={selectedImg}
          setSelectedImg={setSelectedImg}
        />
      )}
      <MuiDialog
        maxWidth="xl"
        open={openDocument}
        title={t('document')}
        content={
          <iframe
            className={styles.fileContainer}
            src={openPath}
            title="File"
          />
        }
        handleClose={() => setOpenDocument(false)}
        deniedText={t('close')}
      />{' '}
      <MuiDialog
        maxWidth="sm"
        open={openNewDocument}
        title={t('projectProgress.new')}
        content={
          <div>
            {' '}
            {loadingFajloviNas && <Spinner />}
            <NoviFajl
              setFile={setFile}
              file={file}
              formData={formData}
              setFormData={setFormData}
            />
          </div>
        }
        handleClose={() => {
          setOpenNewDocument(false);
          setFile([]);
          setFormData(initialDokumenti);
        }}
        handleConfirm={handleSaveDokument}
        deniedText={t('close')}
      />{' '}
      <MuiDialog
        maxWidth="sm"
        open={openDeleteDialog}
        title={t('warning')}
        text={t('warningDelete')}
        handleClose={() => setOpenDeleteDialog(false)}
        handleConfirm={handleDelete}
        loading={loadingDelete}
        deniedText={t('close')}
      />
    </div>
  );
};

export default Dokumentacija;
